import {type TabListState} from '@sail/react-aria';
import {createContext} from 'react';

type ListState = TabListState<unknown> & {collapsed?: boolean};

export const TabListStateContext = createContext<ListState | null>(null);
